export const REFUND_REQUEST_STATUSES = {
  WAITING: '처리 대기',
  APPROVED: '환불 승인',
  REFUNDED: '환불 완료',
  REJECTED: '환불 불가',
};
